import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import FilterTogglerButton from './FilterTogglerButton';
import ListingLayoutTogglers from './ListingLayoutTogglers';
import(`./styles/${window.__litium.themeName}.scss`);

const FilterBar = () => {
  const facetedSearchState = useSelector((state) => state.facetedSearch);

  return (
    <>
      <div className="product-sorting__filter-button">
        <FilterTogglerButton />
      </div>
      <div className="product-sorting__layouts">
        <div className="product-sorting__result-amount">
          {facetedSearchState?.totalCount}{' '}
          {translate('category-filter.results')}
        </div>
        <div className="product-sorting__view-options show-for-large">
          <ListingLayoutTogglers />
        </div>
      </div>
    </>
  );
};

export default FilterBar;
